import { PureComponent } from 'preact-compat'
import { performBulkActionForTopics } from '../../utils'
import { Reply, BulkAction } from '../interfaces'
import Button from '@insided/control/uikit/Button'
import { ConfigContext, filterReplyForBulkAction, getAllVisibleReplies } from '../utils'
import { ContentType } from '@insided/shared/utils/contentType'
import { MoveToExistingTopicModal } from '../MoveToTopic'

interface TopicFooterProps {
  count: number
  showTopicFooter: boolean
  replies: Reply[] | undefined
  contentType: ContentType
  setSelectedReplies: (selectedReplies: string[]) => void
  getReplies: (page?: number, pageSize?: number, sort?: string) => Promise<any>
  handleShowAlert: (type: 'success' | 'error', message?: string) => void
  selectedReplies: string[]
  onShowAlert: (type: 'success' | 'error', message?: string) => void
}

interface TopicFooterState {
  showMoveToExistingTopicModal: boolean
}

class TopicFooter extends PureComponent<TopicFooterProps, TopicFooterState> {
  constructor() {
    super()
    this.state = {
      showMoveToExistingTopicModal: false
    }
  }

  showMoveToExistingTopicModal(show: boolean) {
    this.setState({ showMoveToExistingTopicModal: show })
  }

  performBulkAction = ({ onClick }: BulkAction) => {
    const { contentType, replies, selectedReplies, getReplies, setSelectedReplies, handleShowAlert } = this.props
    const objects: Reply[] | undefined = replies?.filter((reply: Reply) =>
    selectedReplies.includes(reply.id)
    )
    const selectedObjects = filterReplyForBulkAction(contentType, objects)

    onClick(selectedObjects).then(() => {
      getReplies()
      setSelectedReplies([])
    }).catch(() => {
      handleShowAlert('error')
    })
  }

  onSelectAll = (replies: Reply[] | undefined) => {
    const { setSelectedReplies } = this.props
    if (replies === undefined) return
    const selectedReplies = getAllVisibleReplies(replies)
    setSelectedReplies(selectedReplies)
  }

  render () {
    const { count, showTopicFooter, replies, selectedReplies, setSelectedReplies, contentType, getReplies, onShowAlert } = this.props
    const { showMoveToExistingTopicModal } = this.state

    return (
      <ConfigContext.Consumer>
        {({ contentTypeConfig }) => {
          return (
            <footer id='topic-moderation--footer' className={showTopicFooter ? 'show' : ''}>
              <div id='topic-moderation--footer-inner-wrapper'>
                <div className='topic-moderation--footer-posts'>
                  <p>
                    <span data='counter'>{count}</span> {(count === 1) ? 'post' : 'posts'} selected
                  </p>
                  <Button
                    title='Select all'
                    variant='text'
                    onClick={() => this.onSelectAll(replies)}
                    className='topic-moderation__btn-select'
                    data-qa='select-all'
                  />
                  <span className='text-muted'>&ndash; </span>
                  <Button
                    title='Deselect all'
                    variant='text'
                    onClick={() => setSelectedReplies([])}
                    className='topic-moderation__btn-select'
                    data-qa='deselect-all'
                  />
                </div>

                <div className='topic-moderation--footer-actions'>
                  {contentTypeConfig.moveReplyToExistingTopic && <Button
                    title='Move to existing topic'
                    onClick={() => this.showMoveToExistingTopicModal(true)}
                    data-qa='move-replies'
                                                                 />}

                  {showMoveToExistingTopicModal && (
                    <MoveToExistingTopicModal
                      contentType={contentType}
                      selectedReplies={selectedReplies}
                      moveType='Move to existing topic'
                      onClose={() => this.showMoveToExistingTopicModal(false)}
                      getReplies={getReplies}
                      onShowAlert={onShowAlert}
                      setSelectedReplies={setSelectedReplies}
                    />
                  )}

                  <Button
                    title='Trash replies'
                    variant='warning'
                    onClick={() => this.performBulkAction({
                      onClick: async (replies: Reply[] | undefined) => await performBulkActionForTopics(replies, 'trash')
                    })}
                    data-qa='trash-replies'
                  />
                </div>
              </div>
            </footer>
          )
        }}
      </ConfigContext.Consumer>
    )
  }
}

export default TopicFooter
